import React from "react";
import "./Footer.css";

/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer() {
  return (
    <div className="footer-div">
      
        <p className="footer-text" >
          Made with <span role="img">❤️</span> by Shikhar Baniya
        </p>
      
    </div>
  );
}
